import React,{ useEffect } from 'react';
import SignupChatForm from '../../components/forms/SignupForm/SignupChatForm';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import { useParams } from 'react-router-dom';

const SignupChatPage = () => {
  
  const { uid } = useParams();

  return (
    <AuthLayout pageName="signup-chat">
      <SignupChatForm idToken={uid} />
    </AuthLayout>
  );
};

export default SignupChatPage;
